module.exports = __webpack_public_path__ + "bb6fb45e83049c7a6ec6f10c00d5f022.pdf";